import { useCheckSvgIcon } from '#utils/image';
import { Box } from '@material-ui/core';
import React from 'react';
import { SvgComponent } from './SvgComponent';

export const ImageComponent = ({
  src,
  color,
  className = '',
  alt = ''
}: {
  src: string;
  color: string;
  className?: string;
  alt?: string;
}) => {
  const isSvgIcon = useCheckSvgIcon(src);
  return (
    <React.Fragment>
      {isSvgIcon ? (
        <Box className={className}>
          <SvgComponent src={src} color={color} />
        </Box>
      ) : (
        <img src={src} className={className} alt={alt} />
      )}
    </React.Fragment>
  );
};
